import { gql } from 'apollo-angular';
import { Organization } from 'app/modules/organizations-manager/models/organization.model';

export const SEARCH_ORGANIZATIONS_QUERY = gql`
  query SearchOrganizations($searchOrganizationsDto: SearchOrganizationsDto!) {
    orgs: searchOrganizations(searchOrganizationsDto: $searchOrganizationsDto) {
      _id
      orgName
      shortName
      tickerCode
    }
  }
`;

export interface SearchOrganizationsQueryResponse {
  orgs: StakeholderInfo[];
}

export interface SearchOrganizationsDto {
  searchKey?: string;
  verticals?: string[];
}

export type StakeholderInfo = Pick<Organization, '_id' | 'orgName' | 'shortName' | 'tickerCode'>;
